import UIScrollContainer from 'UIComponents/scroll/UIScrollContainer';
import { CONTENT_EMBED_UI_BASE_URL } from '../constants/contentEmbed';
import { usePostMessageToContentEmbed, useReceiveMessageFromContentEmbed } from '../hooks/messaging';
import { useTargetWindow } from '../hooks/useTargetWindow';
import { jsx as _jsx } from "react/jsx-runtime";
const FRAME_ID = `content-embed-ui__full-height-preview--${Date.now()}`;
const ConditionalScrollContainer = ({
  children,
  isFullscreen
}) => !isFullscreen ? /*#__PURE__*/_jsx(UIScrollContainer, {
  "data-test-id": "content-embed-scroll-container",
  style: {
    height: '100%'
  },
  children: children
}) : children;
export const FullHeightPreviewFrame = ({
  className = '',
  html,
  includeHeadElements = false,
  shouldReplaceAllHTML = false,
  isFullscreen = false,
  uniqueFrameId = FRAME_ID,
  iframePropsOverrides = {}
}) => {
  const CONTENT_EMBED_SRC = `${CONTENT_EMBED_UI_BASE_URL}?id=${uniqueFrameId}&includeHeadElements=${includeHeadElements}&shouldReplaceAllHTML=${shouldReplaceAllHTML}`;
  const {
    targetFrameRef,
    targetWindow
  } = useTargetWindow();
  const {
    contentHeight,
    isContentEmbedReady
  } = useReceiveMessageFromContentEmbed(uniqueFrameId);
  usePostMessageToContentEmbed({
    html,
    isContentEmbedReady,
    targetWindow,
    frameId: uniqueFrameId
  });
  return /*#__PURE__*/_jsx(ConditionalScrollContainer, {
    isFullscreen: isFullscreen,
    children: /*#__PURE__*/_jsx("iframe", Object.assign({
      className: className,
      "data-test-id": "content-embed-ui__full-height-preview",
      height: contentHeight,
      id: uniqueFrameId,
      ref: targetFrameRef,
      referrerPolicy: "origin",
      sandbox: "allow-scripts allow-same-origin",
      src: CONTENT_EMBED_SRC
    }, iframePropsOverrides))
  });
};